import React from "react";

import "../css/draggable.css";
import Access from "../Access";
import Button from "@mui/material/Button";
import { CustomDialog } from "../../Component/Dialog";
import { Grid, Box } from "@mui/material";
import { Error } from "@mui/icons-material";
import WorkflowDescriptionModal from "./WorkflowDescription/WorkflowDescriptionModal";
import MainCanvasButtons from "./CanvasButtonsUtil/MainCanvasButtons";
import DraftProductionContent from "./CanvasButtonsUtil/DraftProductionContent";
import KeyboardShortcuts from "../../common/KeyboardShortcuts";
import CanvasPageHeader from "./CanvasPageHeader";

export default class DraftCanvasHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      open: false,
      error: false,
      rerenderBadge: [],
      anchorEl: null,
      openDescriptionDialog: false,
    };
  }

  handleAccess = () => {
    this.props.setOpenAccess(true);
  };

  handleRerenderBadge = () => {
    this.setState({ rerenderBadge: [...this.state.rerenderBadge, 1] });
  };

  handleTest = (open) => {
    this.props.fireTestDialog(open);
  };

  handleRenamePlaceholders = (open) => {
    this.props.fireRenamePlaceholdersDialog(open);
  };

  handleDescriptionClick = () => {
    this.setState({ openDescriptionDialog: true });
  };

  handleDescriptionClose = () => {
    this.setState({ openDescriptionDialog: false });
  };

  render() {
    let disableWF = true;
    const { publishedVersion, draftVersion, lastModified } = this.props;
    const projectStoreState = this.props.ProjectStore.getState();
    const aggregate = projectStoreState.getAggregate();
    const componentDatas = projectStoreState.components;

    if (componentDatas) {
      for (let i = 0; i < componentDatas.length; i++) {
        let t = componentDatas[i].type;
        if (
          t === "form" ||
          t === "bulk_assessment" ||
          t === "webhook" ||
          t === "schedule_start" ||
          t === "trigger_from_a_workflow" ||
          t === "trigger_from_zapier"
        ) {
          disableWF = false;
        }
      }
    }

    const { production, isCanvasLocked, projectId } = this.props;

    const shortcuts = [
      {
        key: "s",
        callback: this.props.saveDraft,
        condition: () => !isCanvasLocked && !this.props.pauseSave,
      },
      {
        key: "p",
        callback: this.props.firePublish,
        condition: () => !isCanvasLocked,
      },
    ];

    return (
      <>
        <KeyboardShortcuts shortcuts={shortcuts} disabled={isCanvasLocked} />
        <CanvasPageHeader
          title={this.props.workflow.name || ""}
          onBack={this.props.handleBack}
          showMoreButton={false}
          isCanvasLocked={isCanvasLocked}
          isEditable={true}
          onTitleChange={(event) =>
            this.props.setWorkflowName(event.target.value)
          }
          onTitleBlur={(event) =>
            this.props.handleSaveProjectAttributes({ name: event.target.value })
          }
          useBpmnJoinBehavior={this.props.workflow.useBpmnJoinBehavior}
          titleBarContent={
            <Box
              className="canvas-header-buttons"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                flexWrap: "nowrap",
                overflow: "hidden",
                width: "100%",
                minWidth: 0,
                "& .MuiGrid-root": {
                  flexWrap: "nowrap !important",
                },
              }}
            >
              <Box sx={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
                <MainCanvasButtons
                  production={production}
                  pauseSave={this.props.pauseSave}
                  saving={this.props.saving}
                  isCanvasLocked={isCanvasLocked}
                  firePublish={this.props.firePublish}
                  updateState={(newState) => this.setState(newState)}
                  anchorEl={this.state.anchorEl}
                  saveDraft={this.props.saveDraft}
                  saveDraftVersion={this.props.saveDraftVersion}
                  handleTest={this.handleTest}
                  publishedVersion={publishedVersion}
                  handleRenamePlaceholders={this.handleRenamePlaceholders}
                  aggregate={aggregate}
                  error={this.props.ProjectStore.getState().error}
                  handleAccess={this.handleAccess}
                  rerenderBadge={this.state.rerenderBadge}
                  setLoadingDialog={this.props.setLoadingDialog}
                  checkUnpublishedChanges={this.props.checkUnpublishedChanges}
                  onDescriptionClick={this.handleDescriptionClick}
                  useBpmnJoinBehavior={this.props.workflow.useBpmnJoinBehavior}
                />
              </Box>
              <Box
                sx={{ flexShrink: 1, ml: 1, overflow: "hidden", minWidth: 0 }}
              >
                <DraftProductionContent
                  changes={this.props.changes}
                  production={production}
                  isCanvasLocked={isCanvasLocked}
                  draftVersion={draftVersion}
                  lastModified={lastModified}
                  publishedVersion={publishedVersion}
                  projectId={projectId}
                />
              </Box>
            </Box>
          }
        />

        <>
          {projectId && this.props.openAccess && (
            <Access
              open={this.props.openAccess}
              history={this.props.history}
              published={
                this.props.ProjectStore.getState().getAggregate()
                  ?.publishedVersion
              }
              projectId={projectId}
              handleRerenderBadge={this.handleRerenderBadge}
              close={() => {
                this.props.setOpenAccess(false);
              }}
            />
          )}

          <WorkflowDescriptionModal
            open={this.state.openDescriptionDialog}
            onClose={this.handleDescriptionClose}
            isCanvasLocked={isCanvasLocked}
            handleSaveProjectAttributes={this.props.handleSaveProjectAttributes}
            workflow={this.props.workflow}
            setWorkflow={this.props.setWorkflow}
          />

          <CustomDialog
            isOpen={this.state.open}
            zIndex={true}
            title={"Fix these issues before you can start the workflow"}
            contents={
              <>
                <p className={"s-text"}>
                  Before you can start and run this workflow, you need to fix
                  the following issues:
                </p>
                {this.state.errors.map((error, index) => {
                  return (
                    <Grid
                      key={index}
                      container
                      xs={12}
                      direction={"row"}
                      alignItems={"center"}
                    >
                      <Grid item xs={1}>
                        <Error className={"error-text"} />
                      </Grid>
                      <Grid item xs={11}>
                        <p className={"error-text"}>{error}</p>
                      </Grid>
                    </Grid>
                  );
                })}
                <p className={"s-text"}>
                  The Start Workflow button will automatically turn green once
                  these issues have been fixed.{" "}
                </p>
              </>
            }
            buttons={
              <>
                <Button
                  onClick={() => {
                    this.setState({ open: false });
                    this.props.firePublish();
                  }}
                  color={"error"}
                  variant={"contained"}
                  disabled={isCanvasLocked}
                >
                  Publish
                </Button>
                <Button
                  variant={"contained"}
                  color={"primary"}
                  onClick={() => {
                    this.setState({
                      open: false,
                    });
                  }}
                  disabled={isCanvasLocked}
                >
                  Done
                </Button>
              </>
            }
          />
        </>
      </>
    );
  }
}
